import { AlertCircle, Users, Wifi, WifiOff } from "lucide-react";
import type { CollabUser } from "@ease/page-builder/collaboration";
import { CollabAvatars } from "./collab-avatars";

interface CollaborationBarProps {
  collaborators: CollabUser[];
  isConnected: boolean;
  connectError?: string | null;
}

export function CollaborationBar({ collaborators, isConnected, connectError }: CollaborationBarProps) {
  if (collaborators.length === 0 && !connectError) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 rounded-lg border border-[var(--color-border)] bg-[var(--color-background)] px-3 py-1.5">
      {isConnected ? (
        <Wifi className="h-4 w-4 text-[var(--color-success)]" />
      ) : (
        <WifiOff className="h-4 w-4 text-[var(--color-muted-foreground)]" />
      )}
      <Users className="h-4 w-4 text-[var(--color-muted-foreground)]" />
      <CollabAvatars collaborators={collaborators} />
      <span className="text-xs text-[var(--color-muted-foreground)]">
        {connectError ? "Realtime unavailable" : `${collaborators.length} connected`}
      </span>
      {connectError ? <AlertCircle className="h-3.5 w-3.5 text-amber-500" /> : null}
    </div>
  );
}

